// extracted by mini-css-extract-plugin
module.exports = {"appNavDropdown":"AppNavLinkDropdown_appNavDropdown__11xIY","appNavDropdownItem":"AppNavLinkDropdown_appNavDropdownItem__3hzCZ"};